import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { PageNotificationService } from './page-notification';
import { CommonService } from './common.service';
import { CodescDTO } from '@signature-it/ngx-generic/models';

@Injectable({
    providedIn: 'root'
})
export class GridService extends CommonService {

    protected gridUrl = `${this.baseUrl}/grid`;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService) {
        super(http, restUrlsConf, notifySvc);
    }

    /**
     * @param _var string
     * @returns Observable<CodescDTO[]>
     */
    getgridById(_id: string): Observable<CodescDTO[]> {
        return this.http.get<CodescDTO[]>(`${this.gridUrl}/${_id}.json`);
    }
}
